export const environment = {
  production: false,
  apiUrl: 'https://instructor-match-api-dev.crio-server.com/api/instructor',
  language: 'en',
};
